/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../bills/tender';
import '../bills/card_data';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "instruments": {
            "nested": {
              "CardSummary": {
                "fields": {
                  "card": {
                    "type": ".squareup.client.bills.CardTender.Card",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardholderName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expirationDate": {
                    "type": ".squareup.client.bills.CardData.KeyedCard.Expiry",
                    "id": 3,
                    "rule": "optional"
                  },
                  "giftCard": {
                    "type": ".squareup.client.instruments.CardSummary.GiftCardSummary",
                    "id": 4
                  }
                },
                "nested": {
                  "GiftCardSummary": {
                    "fields": {
                      "remainingBalance": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "card_brand_summary": {
                    "oneof": ["giftCard"]
                  }
                }
              },
              "InstrumentSummary": {
                "fields": {
                  "instrumentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "card": {
                    "type": ".squareup.client.instruments.CardSummary",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.instruments?.nested?.CardSummary && !$root.nested?.squareup?.nested?.client?.nested?.instruments?.nested?.CardSummary?.nested?.GiftCardSummary && !$root.nested?.squareup?.nested?.client?.nested?.instruments?.nested?.InstrumentSummary) {
  $root.addJSON(jsonData);
}

/**
 * A display version of a Card instrument that is impossible to charge or use to personally
 * identify the card holder.
 *
 * SOURCE CardSummary @ squareup/client/instruments/service.proto at 28:1
 */
export const CardSummary = $root.lookupType('squareup.client.instruments.CardSummary');
fixType(CardSummary, {
  card: {
    required: true
  },
  expirationDate: {
    required: true
  }
});
Builder.createAndAttachToType(CardSummary);
/**
 * Display information for gift card instruments.
 *
 * SOURCE GiftCardSummary @ squareup/client/instruments/service.proto at 39:3
 */
CardSummary.GiftCardSummary = $root.lookupType('squareup.client.instruments.CardSummary.GiftCardSummary');
fixType(CardSummary.GiftCardSummary, {
  remainingBalance: {
    required: true
  }
});
Builder.createAndAttachToType(CardSummary.GiftCardSummary);
/**
 * A version of the Instrument that's intended for display purposes on the client.
 *
 * There's no PAN fidelius information so it's impossible to charge without coming back to this
 * service to request the full Instrument via the token.
 * There's nothing that links this instrument back to a person (i.e. no account token, user token or
 * linking dates).
 *
 * SOURCE InstrumentSummary @ squareup/client/instruments/service.proto at 63:1
 */
export const InstrumentSummary = $root.lookupType('squareup.client.instruments.InstrumentSummary');
fixType(InstrumentSummary, {
  instrumentToken: {
    notEmpty: true
  },
  card: {
    required: true
  }
});
Builder.createAndAttachToType(InstrumentSummary);